import { Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class BlockedSlotSaveFormService {

  constructor(private formBuilder: UntypedFormBuilder) {}

  public initForm(): UntypedFormGroup {
    return this.formBuilder.group(
      {
        clubId: [null, [Validators.required]],
        date: [null, [Validators.required]],
        courtId: [null, [Validators.required]],
        timeFromInMinutes: [null, [Validators.required]],
        timeToInMinutes: [null, [Validators.required]],
        note: [null, [Validators.required]],
        recurring: [null, null],
        typeCode: [null, [Validators.required]]
      }
    );
  }
}

